var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.formSubmitted($event)
        },
      },
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Reward Title", "label-for": "awardTitle" } },
                [
                  _c("b-form-input", {
                    attrs: { name: "awardTitle", placeholder: "Reward Title" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { sm: "12" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Employee", "label-for": "employee" } },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.employeeOptions },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Price", "label-for": "price" } },
                [
                  _c("b-form-input", {
                    attrs: { name: "price", placeholder: "Price" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Gift", "label-for": "gift" } },
                [
                  _c("b-form-input", {
                    attrs: { name: "gift", placeholder: "Gift" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { sm: "12" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Date", "label-for": "date" } },
                [
                  _c("b-form-datepicker", {
                    attrs: { id: "date", placeholder: "Date" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "d-flex justify-content-end", attrs: { md: "12" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-2",
                  attrs: { type: "submit", variant: "primary" },
                },
                [
                  _vm._v("Save"),
                  _vm.loading
                    ? _c("b-spinner", { staticClass: "mx-2" })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "b-button",
                { attrs: { variant: "primary" } },
                [
                  _vm._v("Cancel"),
                  _vm.loading
                    ? _c("b-spinner", { staticClass: "mx-2" })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }